import React from "react"

interface Props {
  name: string
  value: string
  error: string
  touched: boolean
  handleChange: any
  handleBlur: any
  label: string
  errorClass?: string
  options: string[]
}

const SelectInput: React.FC<Props> = ({
  name,
  label,
  value,
  error,
  touched,
  handleChange,
  handleBlur,
  errorClass,
  options = []
}) => {
  return (
    <>
      <label htmlFor={name}>
        {label}:
        {touched && error ? <span className={errorClass}> {error}</span> : null}
      </label>
      <select
        name={name}
        id={name}
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
      >
        {options.map((opt, idx) => (
          <option key={idx}>{opt}</option>
        ))}
      </select>
    </>
  )
}

export default SelectInput
